import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { AdjustmentsHorizontalIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useNavigation } from '@remix-run/react';
import { Collapse, Expand, PrimaryButton, TransparentButton } from '@theprintbar/ui';
import { useEffect, useState } from 'react';
import { CategoryList } from './CategoryList';
import { FilterListProps, ProductFilterKeys, ProductFilterList } from './ProductFilter';

export function MobileFilter(filterData: Omit<FilterListProps, 'expandAll'>) {
	const [expandAll, setExpandAll] = useState(false);
	const [open, setOpen] = useState(false);
	const navigation = useNavigation();

	useEffect(() => {
		setOpen(false);
	}, [navigation.state]);

	const filterCount = ProductFilterKeys.filter(key => !!filterData.params[key]).length;

	return (
		<>
			<button
				onClick={() => {
					setOpen(!open);
				}}
				className="flex items-center"
			>
				<p className="mr-1 text-sm">Filters</p>
				<div className="relative">
					<AdjustmentsHorizontalIcon className="h-5 w-5" />
					{!!filterCount && (
						<div className="absolute -top-1 -right-1.5 rounded-full w-3.5 h-3.5 flex items-center justify-center bg-pink border border-blue">
							<p className="text-[0.7rem]">{filterCount}</p>
						</div>
					)}
				</div>
			</button>
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				transition
				className="relative z-50 transition duration-300 ease-out data-[closed]:opacity-0"
			>
				<DialogBackdrop className="fixed inset-0 bg-black/30" />
				<div className="fixed inset-0 flex justify-center">
					<DialogPanel
						as="div"
						className="gap-4 flex flex-col px-4 py-8 w-screen rounded-3xl bg-white overflow-hidden border border-blue mx-4 h-[80vh] mt-16"
					>
						<div className="flex justify-between items-center">
							<h5 className="font-display font-light text-xl">Filters</h5>
							<TransparentButton
								className="!pr-0 !text-base"
								onClick={() => setExpandAll(!expandAll)}
								icon={expandAll ? Collapse : Expand}
							>
								{expandAll ? 'Collapse All' : 'Expand All'}
							</TransparentButton>
						</div>
						<div className="overflow-y-auto overflow-x-hidden h-full">
							<CategoryList {...filterData} />
							<ProductFilterList {...filterData} expandAll={expandAll} />
						</div>
						<PrimaryButton onClick={() => setOpen(false)} className="w-full mt-auto" icon={XMarkIcon}>
							Close
						</PrimaryButton>
					</DialogPanel>
				</div>
			</Dialog>
		</>
	);
}
